<div class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover directory-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': data.length < 2}">
                <th></th>
                <th (click)="orderBy('suite.suiteNumber', $event)" class="footable-sorted">
                    Unit<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.buildings.length != 1"
                    (click)="orderBy('building.name', $event)">
                    Building <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('licensePlate', $event)">
                    License Plate <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('brand', $event)">
                    Make <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('model', $event)">
                    Model <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('year', $event)">
                    Year <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('color', $event)">
                    Color <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.archivedFilterIsOn()">Status</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data" (click)="toggleCheck(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.suiteNumber}}</td>
                <td *ngIf="directoryService.buildings.length != 1">{{item.buildingName}}</td>
                <td>{{item.licensePlate || '-'}}</td>
                <td>{{item.brand || '-'}}</td>
                <td>{{item.model || '-'}}</td>
                <td *ngIf="!directoryService.showDetailedView">{{item.year || '-'}}</td>
                <td *ngIf="!directoryService.showDetailedView">{{item.color || '-'}}</td>
                <td *ngIf="directoryService.archivedFilterIsOn()">
                    <span *ngIf="directoryService.dateIsEarlierThanCurrent(item.moveOutDate)"
                          title="{{item.moveOutDate | date: 'dd.MM.yyyy'}}"
                          class="label archived-item">
                        Archived
                    </span>
                </td>
            </tr>
            <tr *ngFor="let item of emptyRowService.emptyRow" style="cursor: default;">
                <td><div class="psevdo-checkbox"></div></td>
                <td></td>
                <td *ngIf="directoryService.buildings.length != 1"></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="directoryService.archivedFilterIsOn()"></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!directoryService.directoryData['vehicles'].total"
            [isServiceUnavailable]="directoryService.showServiceUnavailable"
            [isLoading]="directoryService.spinnerShow">
        You have no vehicles listed on the system<br>
        <span *ngIf="directoryService.account.canUpdate('bldn')">
            <a href="javascript://" (click)="directoryService.showModal()" class="mtv-primary-color clickable-text">add a vehicle</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/vehicles-list/vehicles-list.component.html